'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../layout/slick');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)('.slider_review_text').slick({
    infinity: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    accessibility: false,
    adaptiveHeight: true,
    fade: true,
    asNavFor: '.slider_review_img'
  });

  (0, _jquery2.default)('.slider_review_img').slick({
    infinity: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    accessibility: false,
    asNavFor: '.slider_review_text',
    variableWidth: true,
    responsive: [{
      breakpoint: 1441,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        fade: true
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        fade: true
      }
    }]
  });

  (0, _jquery2.default)('.cd-image-container').each(function () {
    var actual = (0, _jquery2.default)(this);
    drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual);
  });

  var sliderRange = document.querySelectorAll('#sliderRange');
  if (sliderRange.length) {
    sliderRange.forEach(function (item) {
      item.addEventListener('input', function (_ref) {
        var value = _ref.target.value;

        (0, _jquery2.default)('.slider_review_img').slick('slickGoTo', value - 1);
      });
    });
  }
});

function drags(dragElement, resizeElement, container) {

  dragElement.on('mousedown touchstart', function (e) {
    dragElement.addClass('draggable');
    resizeElement.addClass('resizable');

    var dragWidth = dragElement.outerWidth(),
        xPosition = dragElement.offset().left + dragWidth - e.pageX,
        containerOffset = container.offset().left,
        containerWidth = container.outerWidth(),
        minLeft = containerOffset + 10,
        maxLeft = containerOffset + containerWidth - dragWidth - 10,
        leftValue = void 0,
        widthValue = void 0;

    dragElement.parents().on('mousemove touchmove', function (e) {
      // console.log(e);
      leftValue = e.pageX + xPosition - dragWidth;

      if (leftValue < minLeft) {
        leftValue = minLeft;
      } else if (leftValue > maxLeft) {
        leftValue = maxLeft;
      }

      widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

      (0, _jquery2.default)('.draggable:not(.slick-list)').css('left', widthValue).on('mouseup touchend', function () {
        (0, _jquery2.default)(this).removeClass('draggable');
        resizeElement.removeClass('resizable');
      });

      (0, _jquery2.default)('.resizable').css('width', widthValue);
    }).on('mouseup touchend', function (e) {
      dragElement.removeClass('draggable');
      resizeElement.removeClass('resizable');
    });
    e.preventDefault();
  }).on('mouseup touchend', function (e) {
    dragElement.removeClass('draggable');
    resizeElement.removeClass('resizable');
  });
}